<template>
  <FormulateForm v-model="form" :errors="errors" :schema="schema" @submit="submitForm" />
</template>
<script>
import Vue from 'vue';
import Alert from '@/web/promotions/Alert';
import { NAME_VALIDATION } from '@/regex/name';

Vue.component('Alert', Alert);

export default {
  props: {
    color: {
      type: String,
      default: 'moles--info',
    },
    errors: {
      type: Object,
    },
    action: {
      type: String,
      default: 'sendPDF',
    },
    showName: {
      type: Boolean,
      default: true,
    },
    showSurname: {
      type: Boolean,
      default: true,
    },
    success: {
      type: Boolean,
      default: null,
    },
  },
  data() {
    return {
      form: {
        name: null,
        surname: null,
        phone: null,
        email: null,
        termsConsent: false,
        isNewsletterSubscriber: false,
      },
    };
  },
  computed: {
    nameField() {
      return {
        name: 'name',
        type: 'text',
        label: 'Nombre',
        placeholder: 'Nombre',
        validation: ['required', 'min:2', ['matches', NAME_VALIDATION]],
        'validation-messages': {
          matches: 'Contiene carácteres incorrectos.',
          required: 'El nombre es obligatorio.',
          min: 'Introduce un nombre de al menos 2 letras.',
        },
      };
    },
    surnameField() {
      return {
        name: 'surname',
        type: 'text',
        label: 'Apellido',
        placeholder: 'Apellido',
        validation: ['required', 'min:2', ['matches', NAME_VALIDATION]],
        'validation-messages': {
          matches: 'Contiene carácteres incorrectos.',
          required: 'El apellido es obligatorio.',
          min: 'Introduce un nombre de al menos 2 letras.',
        },
      };
    },
    phoneField() {
      return {
        label: 'Introduce tu teléfono',
        name: 'phone',
        type: 'phone',
        noExample: true,
        showCodeOnList: true,
        noFlags: true,
        borderRadius: 12,
        translations: {
          phoneNumberLabel: 'Teléfono',
          countrySelectorLabel: 'código de país',
        },
        defaultCountryCode: 'ES',
        validation: 'required|phoneIsValid',
        'validation-messages': {
          required: 'El teléfono es obligatorio.',
          phoneIsValid: 'El número introducido es inválido.',
        },
      };
    },
    emailField() {
      return {
        component: 'div',
        class: 'formulate-input-wrapper-email',
        children: [
          {
            name: 'email',
            type: 'email',
            label: 'Introduce tu mail',
            validation: 'required|email',
            'validation-messages': {
              required: 'El mail es obligatorio.',
              email: 'El formato no es correcto.',
            },
          },
          {
            component: 'div',
            class: 'email-icon-wrapper',
            children: [
              {
                component: 'i',
                class: 'email-input-image',
              },
            ],
          },
        ],
      };
    },
    terms() {
      return {
        name: 'termsConsent',
        type: 'customCheckbox',
        validation: 'accepted',
        'validation-messages': {
          accepted: 'El campo es obligatorio.',
        },
        settings: {
          label: 'He leído y acepto la ',
          link: {
            href: 'https://trioteca.com/legal/politica-de-privacidad',
            text: 'Política de Privacidad.',
          },
          required: true,
        },
      };
    },
    inform() {
      return {
        name: 'isNewsletterSubscriber',
        type: 'customCheckbox',
        settings: {
          label: 'Quiero estar informado en relación a los servicios y productos de Trioteca. Para más información, consulta la ',
          link: {
            href: 'https://trioteca.com/legal/politica-de-privacidad',
            text: 'Política de Privacidad.',
          },
        },
      };
    },
    submitButton() {
      return {
        id: 'contact-button-detalle',
        type: 'submit',
        name: 'submit',
        label: 'Enviar',
      };
    },
    backButton() {
      return {
        component: 'a',
        class: 'popup__button',
        children: 'Volver',
        '@click': this.closePopup,
      };
    },
    alert() {
      return this.success
        ? {
            component: 'Alert',
            class: this.success ? '' : 'hidden',
          }
        : {
            component: 'p',
            class: this.success !== null ? 'form__errors' : 'form__errors hidden',
            children: 'Ha habido un error al procesar tu solicitud.',
          };
    },
    buttons() {
      return {
        component: 'div',
        class: 'popup__buttons popup__buttons--col',
        children: [this.submitButton, this.backButton],
      };
    },
    schema() {
      let schema = [];

      if (this.showName) {
        schema.push(this.nameField);
      }

      if (this.showSurname) {
        schema.push(this.surnameField);
      }

      schema = schema.concat([this.phoneField, this.emailField, this.terms, this.inform, this.alert, this.buttons]);

      return schema;
    },
  },
  methods: {
    submitForm() {
      this.$emit(this.action, this.form);
    },
    closePopup() {
      this.$emit('closePopup');
    },
  },
};
</script>
